import React, { useState } from 'react';
import './sponsoramount.css';
import { useNavigate } from 'react-router-dom';
import { Download } from "lucide-react"; // for nice download icon


function SponsorAmount() {
  const [isOpen, setIsOpen] = useState(false);
  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);

  const [selectedAmount, setSelectedAmount] = useState(null);
  const navigate = useNavigate();




  const [showMessage, setShowMessage] = useState(true); // State to control message visibility

  // Function to close the message
  const handleCloseMessage = () => {
    setShowMessage(false);
  };






  const sponsorshipLevels = [
    { name: "Platinum", amount: "USD 12,000", benefits: ["3x2 meter 3 trade stalls", "15 minutes of 2 product presentations", "60 sec video advertisement at 3 intervals", "Displaying sponsor logos"] },
    { name: "Gold", amount: "USD 7,000", benefits: ["3x2 meter 2 trade stalls", "10 minutes of product presentation", "45 sec video advertisement at 3 intervals", "Displaying sponsor logos"] },
    { name: "Silver", amount: "USD 3,500", benefits: ["3x2 meter 1 trade stall", "30 sec video advertisement at 3 intervals", "Displaying sponsor logos"] },
    { name: "Bronze", amount: "USD 2,000", benefits: ["30 sec video advertisement at 3 intervals", "Displaying sponsor logo"] },
  ];

  const handleSelectAmount = (amount) => {
    setSelectedAmount(amount);
  };

  const handleSponsor = () => {
    if (selectedAmount) {
      navigate('/sponsorPayment', { state: { amount: selectedAmount } });
    } else {
      alert('Please select a sponsorship level.');
    }
  };

  return (
    <div className="donate-amount-container">
      <div className="donate-modal">
        <div className="donate-modal-left">
          <img src="/logo.jpg" alt="Diyatharippu - Optometric Conference" className="logo" />
          <h2>Diyatharippu - Optometric Conference</h2>
          <p><strong>Your support makes a difference!</strong></p>
          <p>Your sponsorship supports the advancement of optometry worldwide, helping to reduce avoidable blindness.</p><br /> <r />
    <a 
      href="/sponsorship.pdf" 
      download
      className="download-btn"
    >
      <Download size={18} />
      Download EYE CARE-2026 Sponsorship Brochure

    </a>

        </div>
        <div className="donate-modal-right">
          <div className="secure-donation">
            {/* <span className="secure-icon">🔒</span> Secure Sponsor */}
          </div>

          <div className="sponsorship-levels">
            {sponsorshipLevels.map((level) => (
              <button 
                key={level.name}
                className={selectedAmount === level.amount ? 'selected' : ''} 
                onClick={() => handleSelectAmount(level.amount)}
              >
                <div className="level-name">{level.name}</div>
                <div className="level-amount"> {level.amount.toLocaleString()}</div>
              </button>
            ))}
          </div>


          {selectedAmount && (
            <div className="benefits-section">
              <h3>Benefits of {sponsorshipLevels.find(level => level.amount === selectedAmount)?.name} Sponsorship</h3>
              <ul>
                {sponsorshipLevels.find(level => level.amount === selectedAmount)?.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>
          )}


      


          <div className="direct-payment">
            <div className="direct-payment-message-content">
              <p>Direct Bank Transfer Details</p>
              <p>Please use the following bank details to complete your transaction:</p>
              <ul>
                <li>Bank Name: HATTON NATIONAL BANK</li>
                <li>Account Holder Name: Community Eye Care Services (Pvt) Ltd</li>
                <li>Account Number: 055010174056</li>
                <li>Bank Code: 7083 </li>
                <li>Branch Code: 55 </li>
                
              </ul>
              <p>After completing the transfer, please send a screenshot or transaction reference to <b>ecinstitute@gmail.com</b> to confirm your payment.</p>
            </div>
          </div>

 







          {/* <div className="faq" onClick={openPopup}>
            <p>Is my sponsor secure?</p>
          </div> */}

          {isOpen && (
            <div className="popup-overlay">
              <div className="popup-box">
                <button className="close-btn" onClick={closePopup}>
                  &times;
                </button>
                <h2>Yes, of course!</h2>
                <p>We use industry-standard <b>SSL encryption</b> to protect your transactions and ensure data security.</p>
                <p>PayHere is <b>PCI-DSS compliant</b>, adhering to global security standards for handling sensitive financial information.</p>
                <p>Your payment details are never stored on our servers. Instead, all data is securely transmitted through bank-level encryption and processed directly by PayHere’s PCI-certified payment partners.</p>
              </div>
            </div>
          )}



        </div>
      </div>
    </div>
  );
}

export default SponsorAmount;

